import { Link, Typography } from '@iheartjane/reefer';

export const JaneGoldTermsLink = ({
  finePrint,
  label = 'Terms and conditions apply',
}: {
  finePrint?: boolean;
  label?: string;
}) => {
  return (
    <Link
      href="https://www.iheartjane.com/terms"
      color={finePrint ? 'text-light' : 'text-main'}
    >
      <Typography
        as="span"
        variant={finePrint ? 'mini' : 'body'}
        color={finePrint ? 'text-light' : 'text-main'}
      >
        {label}
      </Typography>
    </Link>
  );
};
